<template lang="pug">
.nav_tab.i_mlr_6.i_mlr_md_4.i_mlr_sm_2.flex-shrink-0.flex-shrink-md-1.flex-grow-0(
  :class="{ selected: selected }"
)
  h5.text-center {{ title }}
</template>

<script>
export default {
  name: "NavTab",
  components: {},
  props: {
    title: String,
    selected: Boolean,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/product/nav_tab";
</style>
